import { render, staticRenderFns } from "./Record.vue?vue&type=template&id=5cb12c77&scoped=true&"
import script from "./Record.vue?vue&type=script&lang=js&"
export * from "./Record.vue?vue&type=script&lang=js&"
import style0 from "./Record.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Record.vue?vue&type=style&index=1&id=5cb12c77&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb12c77",
  null
  
)

export default component.exports